import { defaultTheme } from '@treezor/design-system';

export interface IInformationBlockProps {
  title: string;
  value?: string;
  variant?: keyof typeof defaultTheme.palette;
}

export function InformationBlock({ title, value, variant }: IInformationBlockProps) {
  return (
    <div className="flex flex-col">
      <span className="typo-body-regular-paragraph text-tertiary">{title}</span>
      {value && (
        <p className="typo-body-medium-paragraph text-primary" style={{ color: defaultTheme.palette[variant] }}>
          {value}
        </p>
      )}
    </div>
  );
}
